import { EdlAuthServicesModule, EdlCommonRegistrationModule } from '@edl-development/edl-auth';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RegistrationStates } from './registration.states';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { UIRouterModule } from '@uirouter/angular';
import { LaddaModule } from 'angular2-ladda';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';




@NgModule({
  declarations: [
  ],
  imports: [
    CommonModule,
    FormsModule,
    UIRouterModule.forChild({
      states: RegistrationStates
    }),
    LaddaModule,
    ReactiveFormsModule,
    NgbModule,
    EdlAuthServicesModule,
    EdlCommonRegistrationModule
  ]
})
export class RegistrationModule { }
